<template>
  <v-bottom-sheet
    v-model="show"
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
  >
    <v-card>
      <v-card-title class="headline">
        Change Subscription
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="$emit('pause')"
        >
          <v-icon left>
            {{ paused ? 'mdi-play' : 'mdi-pause' }}
          </v-icon>
          {{ paused ? 'Resume' : 'Pause' }}
        </v-btn>
        <v-btn
          @click="$emit('cancel')"
        >
          <v-icon left>
            mdi-delete
          </v-icon>Cancel
        </v-btn>
        <v-btn
          icon
          @click="$emit('close')"
        >
          <v-icon>mdi-cancel</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
export default {
  props: ['show', 'paused'],
  methods: {
    takeAction(yes) {
      this.$emit(yes ? 'clickedYes' : 'clickedNo')
    }
  }
}
</script>